// 後方互換シム。年度別に分割した新しい場所からそのまま re-export する。
// 既存 import (`exhibitorApplicationSchema`, `calculateFees` 等) は 2025 のものを指す。
// 2026 用には `exhibitorApplication2026Schema` / `calculateFees2026` を直接 import する。

import { z } from 'zod';

export {
  exhibitorStatusSchema,
  exhibitorTypeSchema,
  exhibitDaySchema,
  boothSizePreferenceSchema,
  exhibitorAdminUpdateSchema,
  exhibitorEditableSchema,
  type ExhibitorStatus,
  type ExhibitorType,
  type ExhibitDay,
  type BoothSizePreference,
  type ExhibitorAdminUpdateInput,
} from '../exhibitor/core';

export {
  powerCapacity2025Schema as powerCapacitySchema,
  exhibitorApplication2025Schema as exhibitorApplicationSchema,
  exhibitorAdminFullUpdate2025Schema as exhibitorAdminFullUpdateSchema,
  type PowerCapacity2025 as PowerCapacity,
  type ExhibitorApplication2025Input as ExhibitorApplicationInput,
  type ExhibitorAdminFullUpdate2025Input as ExhibitorAdminFullUpdateInput,
} from '../exhibitor/y2025/application';

import { exhibitorApplication2025Schema } from '../exhibitor/y2025/application';

// 旧 exhibitorUpdateSchema (= application.partial().extend({id})) も互換のため残す
export const exhibitorUpdateSchema = exhibitorApplication2025Schema.partial().extend({
  id: z.string(),
});
export type ExhibitorUpdateInput = z.infer<typeof exhibitorUpdateSchema>;
